//Definición de los colores para el tema de la aplicación
let primaryColor = {
  light: "#58e46f",
  main: "#235B4E",
  dark: "#00800d",
  contrastText: "#FFFFFF",
};

export default primaryColor;
